/*
*###############################################################################
*Module Name                   : DPSwitch.js                                   #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Tuesday, August 24th 2021, 1:47:16 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from "react"
import { Row, Label, Input } from "reactstrap"
import Switch from "react-switch"

const DPSwitch = ({
  rowClass,
  divClass,
  onChange,
  checked,
  disabled,
  id,
  name
}) => {
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        No
      </div>
    )
  }

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  const Configs = {
    buttons: "round",
    toolBarButtons: "round",
    toolBarIconType: "mdi",
    toolBarIconPlace: "left",
    height: 23,
    handleDiameter: 15
}

  const swheight = Configs.height
  const swhandleDiameter = Configs.handleDiameter
  return (
    <Row className={rowClass}>
      <div className={divClass == "" ? "col-md-12 mb-1" : divClass}>
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          onColor="#626ed4"
          name={name}
          onChange={onChange}
          checked={checked == true ? true : false}
          disabled={disabled}
          height={swheight}
          id={id}
          handleDiameter={swhandleDiameter}
          defaultValue={false}
        />
      </div>
    </Row>
  )
}

export default DPSwitch
